import type { BaseRegistration, Dict, RegistrationDisposer } from 'piral-core'
import { buildName, type GlobalState, type PiralPlugin } from 'piral-core'
import type React from 'react'
import * as actions from './actions'

declare module 'piral-core/lib/types/custom' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface PiletCustomApi extends TrayApi {}

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface PiralCustomState {}

  interface PiralCustomActions {
    registerTrayItem(name: string, value: TrayRegistration): void
    unregisterTrayItem(name: string): void
  }

  interface PiralCustomRegistryState {
    trayItems: Dict<TrayRegistration>
  }
}

export interface TrayRegistration extends BaseRegistration {
  component: () => React.ReactNode
}

export interface TrayApi {
  registerTray(name: string, component: () => React.ReactNode): RegistrationDisposer
  unregisterTray(name: string): void
}

function withEmptyTrayItems() {
  return (state: GlobalState): GlobalState => ({
    ...state,
    registry: {
      ...state.registry,
      trayItems: {}
    }
  })
}

export function createTrayApi(): PiralPlugin<TrayApi> {
  return (context) => {
    context.defineActions(actions)
    context.dispatch(withEmptyTrayItems())

    return (_api, target) => {
      const pilet = target.name
      let next = 0

      return {
        registerTray(name, component): RegistrationDisposer {
          const internalName = name || next++
          const id = buildName(pilet, internalName)
          context.registerTrayItem(id, {
            pilet,
            component
          } satisfies TrayRegistration)
          return () => context.unregisterTrayItem(id)
        },
        unregisterTray(name) {
          const id = buildName(pilet, name)
          context.unregisterTrayItem(id)
        }
      }
    }
  }
}
